<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="发票下载"
    width="40%"
    :append-to-body="true"
    :modal-append-to-body="false"
  >
    <span v-if="params.source == 'invoiceSuccess'">开票成功！</span>
    <span>请确认将发票文件“发送到邮箱”还是“下载到本地”？</span>
    <div
      v-if="params.source == 'invoiceSuccess'"
      style="color: red; font-weight: bold; margin-top: 15px"
    >
      注：如果此时未下载发票，后续则需要到"票据打印及退费申请"功能中找到相应的收款记录进行发票下载！
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button :loading="doing" @click="sendMail" type="primary">发送发票到邮箱</el-button>
        <el-button :loading="doing" @click="downloadFile" type="primary">下载发票到本地</el-button>
        <el-button :loading="doing" @click="doClose">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  getDetail as getInvoiceDetail,
  sendEmail,
} from '@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord.js';

export default {
  data() {
    return {
      params: {},
      dialogVisible: false,
      doing: false,
    };
  },
  methods: {
    //父组件调用
    openDialog(params) {
      this.params = params || {};
      if (!this.params.invoiceUrl) {
        getInvoiceDetail({ invoiceNo: this.params.invoiceNo }).then(res => {
          if (res.data.feeInvoiceInfo) {
            this.params.invoiceUrl = res.data.feeInvoiceInfo.invoiceUrl;
          }
        });
      }
      this.dialogVisible = true;
    },
    sendMail() {
      this.doing = true;
      this.$prompt('接收邮箱地址', '发票下载-发送邮箱', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputPattern: /^(\w+)(\.\w+)*@(\w+)(\.\w+)*.(\w+)$/i,
        inputErrorMessage: '邮箱格式不正确',
      })
        .then(({ value }) => {
          sendEmail({
            invoiceUrl: this.params.invoiceUrl,
            invoiceNo: this.params.invoiceNo,
            receiveEmail: value,
          })
            .then(() => {
              this.$message.success('发送成功！');
              this.doing = false;
              this.doClose();
            })
            .catch(() => {
              this.doing = false;
            });
        })
        .catch(() => {
          this.doing = false;
        });
    },
    downloadFile() {
      this.doing = true;
      const link = document.createElement('a');
      link.href = this.params.invoiceUrl;
      link.setAttribute('download', this.params.invoiceNo);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$alert('下载成功！请在浏览器下载记录中打开发票文件！', '发票下载成功提示', {
        confirmButtonText: '确定',
      });
      this.doing = false;
      this.doClose();
    },
    doClose() {
      this.params = {};
      this.dialogVisible = false;
      this.$emit('close');
    },
  },
};
</script>
